const CLARITY_HOMOLOG_PROJECT_ID = "oy0dpwi3er";
const CLARITY_PROD_PROJECT_ID = "oy06miqst6";

export const CLARITY_PROJECT_ID =
    process.env.NODE_ENV === "production"
        ? CLARITY_PROD_PROJECT_ID
        : CLARITY_HOMOLOG_PROJECT_ID;
